module.exports = __webpack_public_path__ + "img/kissing-grandma.0e0731ff.png";